export default __webpack_public_path__ + "a0d441ba84399f96d76d26026774b4f6.png";